import { render } from "./ReprendreSessionPage.vue?vue&type=template&id=6c2ccd1d&ts=true"
import script from "./ReprendreSessionPage.vue?vue&type=script&lang=ts"
export * from "./ReprendreSessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__